import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Card, Input, Button, message } from "antd";
import { resetPassword } from "../../apis/authApi";

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      message.error("Passwords do not match.");
      return;
    }

    try {
      setLoading(true);

      const response = await resetPassword(token, password);

      if (response.status !== 200) {
        throw new Error(response.data?.message || "Something went wrong");
      }

      message.success("✅ Password reset successful! Redirecting to login...");
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      message.error(`❌ ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center h-screen bg-gray-100">
      <Card className="w-full max-w-md shadow-xl rounded-2xl">
        <h2 className="text-2xl font-bold mb-4 text-center">
          Restablece tu contraseña
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <Input.Password
            placeholder="New Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <Input.Password
            placeholder="Confirm New Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            block
          >
            Reset Password
          </Button>
        </form>
      </Card>
    </div>
  );
}
